// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"CwToolbar-toolbar","overflowButtons":"CwToolbar-overflowButtons","rightButtons":"CwToolbar-rightButtons"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwtoolbar/CwToolbar.scss
// module id = 395
// module chunks = 0